import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { Form, Formik } from 'formik';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import Button from '@mui/material/Button';
import { MyTextField, useStyles } from '../Categories/AddCategory';
import jwtAxios from '../../../services/axiosInstance/ApiConfig';
import { showErrorMessage, showSuccessMessage } from '../../../common/Toaster';
import UploadImage from '../../../common/UploadImage';
import { getHeaders } from '../../../store/actions/Auth';
import { onGetAllProducts } from '../../../store/actions/productActions';
import { addProductSchema } from '../../../schemas/addProduct.schema';
import { AppState } from '../../../store';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import { onImageUpload } from '../../../store/actions/uploadAction';
import { SET_UPLOAD_URL } from '../../../store/types/actions/ProductAction';
import CustomMultiSelect from '../../../common/CustomMultiSelect';
import { productColorsList, productSizeList } from '../../../utils';

const otherDetailButtonList: any = [
	{ label: 'Product detail', value: 'prod_detail' },
	{ label: 'About product', value: "about_prod" },
	{ label: 'Additional Info', value: 'additional_info' }
];

interface AddProductProps {
	setOpen: (open: boolean) => void;
	selectedProduct: any;
}

interface AddProductState {
	name: string;
	image: string;
	price: number;
	countInStock: number;
	brand: string;
	rating: number;
	numReviews: number;
	colors: Array<string>;
	size: Array<string>;
	availableInLocations: string;
}

const AddProduct = (props: AddProductProps) => {
	const { selectedProduct } = props;
	console.log(selectedProduct)
	const [values] = useState<AddProductState>(selectedProduct ? {...selectedProduct} : {
		name: '',
		price: 0,
		countInStock: 0,
		brand: '',
		rating: 0,
		numReviews: 0,
	})

	const [category, setCategory] = useState(selectedProduct ? selectedProduct.category : '')
	const [subcategory, setSubCategory] = useState(selectedProduct ? selectedProduct.subcategory : '')
	const [colors, setColors] = React.useState<string[]>(selectedProduct ? selectedProduct.colors.split(", ") : []);
	const [size, setSize] = React.useState<string[]>(selectedProduct ? selectedProduct.size.split(", ") : []);
	const [otherDetailType, toggleOtherDetailForm] = useState({ value: 'prod_detail', index: 0});
	
	const {categories, subcategories} = useSelector<AppState, AppState['categories']>(
        ({categories}) => categories,
    );
	
	const [filteredSubCategories, setFilteredSubCategories] = useState(subcategories)

	const {imageUrl} = useSelector<AppState, AppState['products']>(
        ({products}) => products,
    );

	const classes: any = useStyles(props);
	const dispatch = useDispatch()

	const submitHandler = (data: AddProductState, setSubmitting: any) => {
		let payload = {
			...data,
			image: imageUrl,
			category,
			subcategory,
			colors,
			size,
			availableInLocations: [data.availableInLocations]
		}
		setSubmitting(true);
		if(!selectedProduct) {
			jwtAxios.post('/products/addProduct', payload, { headers: getHeaders()})
				.then(response => {
					showSuccessMessage(response.data.message)
					dispatch(onGetAllProducts({}))
					props.setOpen(false)
				}).catch((err: any) => showErrorMessage(err))
		} else {
			if(!payload.image) {
				payload.image = selectedProduct.image
			}
			jwtAxios.put('/products/editProduct/' + selectedProduct.id, payload, { headers: getHeaders()})
				.then(response => {
					showSuccessMessage(response.data.message)
					dispatch(onGetAllProducts({}))
					props.setOpen(false)
				}).catch((err: any) => showErrorMessage(err))
		}
		setSubmitting(false);
	}

	const handleSelectChange = (event: SelectChangeEvent) => {
		const { name, value } = event.target
		if(name === 'category') {
			const category = categories.filter((c: any) => c.name === value)[0]
			const filteredSubCategories = subcategories.filter((subc: any) => subc.category_id === category._id)
			setFilteredSubCategories(filteredSubCategories)
			setCategory(value)
		}
		else setSubCategory(value)
	}

	const handleImageUpload = (event: any) => {
		dispatch({ type: SET_UPLOAD_URL, payload: null })
		const file = event.target.files[0];
        const bodyFormData = new FormData();
        bodyFormData.append('image', file);
		dispatch(onImageUpload(bodyFormData))
	}

	const otherButtonList: any = () => {
		return otherDetailButtonList.map((button: any, index: number) =>
			<Button
				color={otherDetailType.index === index ? "secondary" : "inherit"}
				variant="contained"
				size='small'
				className={clsx(classes.signInButton)}
				onClick={() => {
					toggleOtherDetailForm({ value: button.value, index });
				}}
				sx={{mb: 1}}
			>
				<Box component="span" sx={{ml:1}}>{button.label}</Box>
			</Button>
		)
	}

	const addProductDetailForm = () => {
		return <>
			<Grid item xs={12} sm={4}>
				<Box mb={{ xs: 2, xl: 3 }}>
					<MyTextField
						id="material-type"
						placeholder='material type'
						name='materialType'
						label='Material Type'
						variant='outlined'
						size="small"
					/>
				</Box>
			</Grid>
			<Grid item xs={12} sm={4}>
				<Box mb={{ xs: 2, xl: 3 }}>
					<MyTextField
						id="sleeve-type"
						placeholder='Sleeve type'
						name='sleeveType'
						label='Sleeve Type'
						variant='outlined'
						size="small"
					/>
				</Box>
			</Grid>
			<Grid item xs={12} sm={4}>
				<Box mb={{ xs: 2, xl: 3 }}>
					<MyTextField
						id="length"
						placeholder='length'
						name='length'
						label='Length'
						variant='outlined'
						size="small"
					/>
				</Box>
			</Grid>
			<Grid item xs={12} sm={4}>
				<Box mb={{ xs: 2, xl: 3 }}>
					<MyTextField
						id="neck-style"
						placeholder='Neck style'
						name='neckStyle'
						label='Neck Style'
						variant='outlined'
						size="small"
					/>
				</Box>
			</Grid>
			<Grid item xs={12} sm={4}>
				<Box mb={{ xs: 2, xl: 3 }}>
					<MyTextField
						required
						id="style"
						placeholder='Style'
						name='style'
						label='Style'
						variant='outlined'
						size="small"
					/>
				</Box>
			</Grid>
			<Grid item xs={12} sm={4}>
				<Box mb={{ xs: 2, xl: 3 }}>
					<MyTextField
						required
						id="coo"
						placeholder='Country of origin'
						name='countryOfOrigin'
						label='Country of origin'
						variant='outlined'
						size="small"
					/>
				</Box>
			</Grid>
		</>
	}

	return (
		<Box display="flex" flexDirection="column">
			<Box display="flex" justifyContent="space-between" p={1}>
				<Box component="h4">{selectedProduct ? `Edit Product: ( ${selectedProduct.name} )`: 'Add Product '}</Box>
				<Button
					color="error"
					variant="contained"
					className={clsx(classes.signInButton)}
					onClick={() => props.setOpen(false)}
				>
					Close
				</Button>
			</Box>
			<Paper className={classes.paper}>
				<Box component="h6" pt={1} pl={2}>Please provide all the information required(*).</Box>
				<Box flex={1} display='flex' p={2} flexDirection='column'>
					<Formik
						validateOnChange={true}
						initialValues={{...values}}
						validationSchema={addProductSchema}
						onSubmit={(data, { setSubmitting }) => submitHandler(data, setSubmitting)}>
						{({ isSubmitting }) => (
							<Form noValidate autoComplete="off">
								<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
									<Grid item xs={12} sm={3}>
										<Box mb={{ xs: 2, xl: 3 }}>
											<FormControl fullWidth variant="outlined" size='small'>
												<InputLabel id="category-list-label">Select Category</InputLabel>
												<Select
													labelId="category-list-label"
													id="category-list"
													name="category"
													label="Select category"
													defaultValue={category}
													onChange={handleSelectChange}
												>
													{categories && categories.length > 0 && categories.map((category: any) => {
														return <MenuItem key={category._id} value={category.name}>{category.name}</MenuItem>
													})}
												</Select>
											</FormControl>
										</Box>
									</Grid>
									<Grid item xs={12} sm={3}>
										<Box mb={{ xs: 2, xl: 3 }}>
											<FormControl fullWidth variant="outlined" size='small'>
												<InputLabel id="sub-category-list-label">Select Sub Category</InputLabel>
												<Select
													labelId="sub-category-list-label"
													id="sub-category-list"
													name="subcategory"
													label="Choose sub category"
													defaultValue={subcategory}
													onChange={handleSelectChange}
													variant='outlined'
												>
													{filteredSubCategories && filteredSubCategories.length > 0 && filteredSubCategories.map((subc: any) => {
														return <MenuItem key={subc._id} value={subc.name}>{subc.name}</MenuItem>
													})}
												</Select>
											</FormControl>
										</Box>
									</Grid>
									<Grid item xs={12} sm={3}>
										<Box mb={{ xs: 2, xl: 3 }}>
											<MyTextField
												required
												id="product-brand"
												placeholder='Brand'
												name='brand'
												label='Enter Brand'
												variant='outlined'
												size="small"
											/>
										</Box>
									</Grid>
									<Grid item xs={12} sm={3}>
										<Box mb={{ xs: 2, xl: 3 }}>
											<MyTextField
												required
												id="product-name"
												placeholder='product name'
												name='name'
												label='Product Name'
												variant='outlined'
												size="small"
											/>
										</Box>
									</Grid>
									<Grid item xs={6} sm={3}>
										<Box mb={{ xs: 2, xl: 3 }}>
											<MyTextField
												required
												id="product-price"
												placeholder='Price'
												name='price'
												type="number"
												label='Product Price'
												variant='outlined'
												size="small"
											/>
										</Box>
									</Grid>
									<Grid item xs={12} sm={3}>
										<Box mb={{ xs: 2, xl: 3 }}>
											<MyTextField
												required
												id="product-count-in-stock"
												placeholder='Counts in stock '
												name='countInStock'
												type="number"
												label='Count In Stock'
												variant='outlined'
												size="small"
											/>
										</Box>
									</Grid>
									<Grid item xs={12} sm={3}>
										<Box mb={{ xs: 2, xl: 3 }}>
											<MyTextField
												required
												id="product-rating"
												placeholder='Product rating'
												name='rating'
												type="number"
												label='Rating'
												variant='outlined'
												size="small"
											/>
										</Box>
									</Grid>
									<Grid item xs={12} sm={3}>
										<Box mb={{ xs: 2, xl: 3 }}>
											<MyTextField
												required
												id="product-total-reviews"
												placeholder='Total reviews'
												name='numReviews'
												type="number"
												label='Total Reviews'
												variant='outlined'
												size="small"
											/>
										</Box>
									</Grid>
									<Grid item xs={12} sm={3}>
										<CustomMultiSelect
											name="colors"
											placeholder="Red, White, Black"
											label="Select Colors"
											selectedOption={colors}
											options={productColorsList}
											handleChangeOption={(option) => setColors(option)}
										/>
									</Grid>
									<Grid item xs={12} sm={3}>
										<CustomMultiSelect
											name="size"
											placeholder="S, M, L"
											label="Select Size"
											selectedOption={size}
											options={productSizeList}
											handleChangeOption={(option) => setSize(option)}
										/>
									</Grid>
									<Grid item xs={12} sm={3}>
										<MyTextField
											required
											id="product-availability"
											placeholder='Enter comma seperated pincode'
											name='availableInLocations'
											label='Product Availability'
											variant='outlined'
											size="small"
										/>
									</Grid>
									<Grid item xs={12} sm={3}>
										<UploadImage
											onChange={handleImageUpload}
											imageUrl={imageUrl || ''}
											existingProdImageUrl={selectedProduct && selectedProduct.image} 
										/>
									</Grid>
									<Grid item xs={12} sm={12} mt={2}>
										<Box component="h6">Please provide some additional information(Optional).</Box>
									</Grid>
									<Grid item xs={12} sm={12}>
										<Box display="flex" columnGap={.5}>
											{otherButtonList()}
										</Box>
									</Grid>
									{otherDetailType.value === 'prod_detail' && otherDetailType.index === 0 && 
										addProductDetailForm()
									}
									{otherDetailType.value === 'about_prod' && otherDetailType.index === 1 && 
										<>about product form</>
									}
									{otherDetailType.value === 'additional_info' && otherDetailType.index === 2 && 
										<>additional info form</>
									}
								</Grid>
								<Box
									mb={1}
									mt={6}
									columnGap={2}
									display='flex'
									flexDirection={{ xs: 'column', sm: 'row' }}
									justifyContent='flex-end'>
									<Button
										color="secondary"
										variant="outlined"
										className={clsx(classes.signInButton)}
										onClick={() => props.setOpen(false)}
									>
										Cancel
									</Button>
									<Button
										color="primary"
										variant="contained"
										type="submit"
										disabled={isSubmitting}
										className={clsx(classes.signInButton)}>
										{selectedProduct ? "Save" : "Submit"}
									</Button>
								</Box>
							</Form>
						)}
					</Formik>
				</Box>
			</Paper>
		</Box>
	);
};

export default AddProduct;
